import { Colors, Row } from '@microfrontends/react-components'
import styled from 'styled-components'
const sectionPadding = '35px 0'

export const Container = styled(Row)`
	background-color: #fff;
`

export const SlideRulingNumberCss = styled.section`
	background-color: ${Colors.primary};
	background-image: url(${process.env.IMAGE_BASE_URL}/numerology/base-bg.png);
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	padding: 35px 0;
	position: relative;
	height: 100%;
	@media screen and (min-width: 768px) {
	}
`
export const SliderWrapCss = styled(Row)`
	position: relative;
`

export const DetailCss = styled(Row)`
	background-color: #fff;
	padding: ${sectionPadding};
	.vnw-collapse-header {
		padding: 10px 12px;
	}
	@media screen and (min-width: 768px) {
		.vnw-collapse-header {
			padding: 10px 48px;
		}
	}
`
export const FamosPeopleCss = styled(Row)`
	padding: ${sectionPadding};
	padding-top: 0;
`
